import { render } from "./App.vue?vue&type=template&id=4e6e1bbe"
const script = {}

import exportComponent from "D:\\vue.js-tut\\czn\\online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__